import { isFulfilled } from "@reduxjs/toolkit";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { getIds } from "../../../app/common";
import { useAppDispatch } from "../../../app/hooks";
import DialogComponent from "../../../common/components/functional/dialogs/DialogComponent";
import DialogContentWrapper from "../../../common/components/functional/dialogs/DialogContentWrapper";
import { RecruitmentsAreaForm } from "./RecruitmentsAreaForm";
import { createNewRecruitmentArea } from "./recruitmentsSlice";
import { RecruitmentAreaForm } from "./types";

type Props = {
  open: boolean;
  close: () => void;
};

const AddRecruitmentArea = ({ open, close }: Props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const defaultValues = {
    name: "",
    members: [],
    cities: [],
    isTeamArea: false, // TODO: this is not needed?
  };

  const methods = useForm<RecruitmentAreaForm>({
    defaultValues,
    mode: "onChange",
  });

  const onSubmit = (data: RecruitmentAreaForm) => {
    const payload = {
      name: data.name,
      experts: getIds(data.members),
      cities: getIds(data.cities),
    };
    dispatch(createNewRecruitmentArea(payload)).then((action) => {
      if (isFulfilled(action)) {
        close();
      }
    });
  };

  return (
    <DialogComponent
      open={open}
      onClose={close}
      variant="form"
      sx={{ width: "700px" }}
    >
      <DialogContentWrapper title={t("settings:addRecruitmentArea")} margin>
        <FormProvider {...methods}>
          <RecruitmentsAreaForm onSubmit={onSubmit} close={close} isNew />
        </FormProvider>
      </DialogContentWrapper>
    </DialogComponent>
  );
};

export default AddRecruitmentArea;
